import React, { useState, useEffect } from 'react';
import { variables } from '../Variables/Variable';
import { Slide, toast } from 'react-toastify';
import SwiperCore, { Autoplay, Pagination, Navigation } from 'swiper/core';
import "swiper/css";
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { CustomLeftArrow, CustomRightArrow } from './Arrow/Arrow';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
const responsive = {
    largeDesktop: {
        breakpoint: { max: 4000, min: 3000 },
        items: 5
    },
    desktop: {
        breakpoint: {
            max: 3000,
            min: 1024
        },
        items: 3,
        partialVisibilityGutter: 40
    },
    mobile: {
        breakpoint: {
            max: 464,
            min: 0
        },
        items: 1,
        partialVisibilityGutter: 30
    },
    tablet: {
        breakpoint: {
            max: 1024,
            min: 464
        },
        items: 2,
        partialVisibilityGutter: 30
    }
};
const Home = () => {
    const [slides, setSlides] = useState([]);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");
    const [brands, setBrands] = useState([]);
    const [shuffledContent, setShuffledContent] = useState([]);
    const [about,setAbout] = useState();
    const [contact,setContact] = useState();
    const [aboutText,setAboutText] = useState([]);

    SwiperCore.use([Autoplay, Pagination, Navigation]);

    function isValid() {
        if (email == "" || name == "" || message == "") {
            toast.error("please fill required fields");
            return false;
        }
        return true;
    }

    const getSlides = async (SlideName) => {
        await fetch(variables.API_URL + "Slider/GetSlidesBySliderName/" + SlideName, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        }).then((resp) => {
            if (resp.ok) {
                return resp.json();
            }
        }).then((result) => {
            setSlides(result);
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (isValid()) {
            fetch(variables.API_URL + "Contact/SendEmailFromHome/", {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": variables.API_URL,
                },
                body: JSON.stringify({
                    Name: name,
                    Email: email,
                    Message: message
                }),
            })
                .then((Response) => {
                    if (Response.ok) {
                        toast.success("Email sent Sucessfully");
                        setName(""); setEmail(""); setPhone(""); setMessage("");
                        return Response.json();
                    }
                })
        }
    }
    const getBrands = () => {
        fetch(variables.API_URL + "Brand/GetBrands", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": variables.API_URL,
            },
        })
            .then((Response) => {
                if (Response.ok) {

                    return Response.json();
                }
            }).then((Result) => {
                setBrands(Result);
            })
    }
    const getShuffledContent = () => {
        fetch(variables.API_URL + "Content/GetShuffledContents", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": variables.API_URL,
            },
        })
            .then((Response) => {
                if (Response.ok) {

                    return Response.json();
                }
            }).then((Result) => {
                setShuffledContent(Result);
            })
    }
    const getAbout = () => {
        fetch(variables.API_URL + "About/GetAbout", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": variables.API_URL,
            },
        })
            .then((Response) => {
                if (Response.ok) {

                    return Response.json();
                }
            }).then((Result) => {
                if(Result.Text) {
                    var text = Result.Text.split("<br />");
                    setAboutText(text);
                }
                setAbout(Result);
            })
    }
    const getContact = () => {
        fetch(variables.API_URL + "Contact/GetContact", {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": variables.API_URL,
            },
        })
            .then((Response) => {
                if (Response.ok) {

                    return Response.json();
                }
            }).then((Result) => {
                setContact(Result);
            })
    }

    useEffect(() => {
        getSlides("Home");
        getBrands();
        getShuffledContent();
        getAbout();
        getContact();
    }, [])
    return (
        <>
            <section className="main-slider main-slider-one main-slider-one--two homeslider"  >
                <div className="swiper swiper-container thm-swiper__slider" >

                    <div className="swiper-wrapper">

                        {/* <!--Start Single Swiper Slide--> */}
                        {
                            slides.map((slide,index) => {
                                return (

                                    <div key={index} className="swiper-slide">
                                        <div className="image-layer"
                                            style={{ backgroundImage: `url(${variables.PHOTO_URL + slide.Image})` }}></div>
                                        <div className="container">
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className="main-slider-one__inner">
                                                        <div className="border-box"></div>
                                                        <p className="main-slider-one__text">{slide.Title}.
                                                        </p>
                                                        {/*<h2 className="main-slider-one__title">my Floor, Your <br />Lifestyle, Our Passion
                                                        </h2>*/}
                                                        <h2 className="main-slider-one__title">{slide.Subtitle}
                                                        </h2>
                                                        <div className="main-slider-one__btn">
                                                            <a href="/Gallery/7" className="thm-btn">View Gallery</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        {/* <!--End Single Swiper Slide--> */}
                    </div>

                    {/* <!-- If we need navigation buttons --> */}
                    <div className="swiper-pagination" id="main-slider-pagination"></div>
                    <div className="swiper-button-next" style={{color: "#f37e21"}}></div>
                    <div className="swiper-button-prev" style={{color: "#f37e21"}}></div>
                </div>
            </section>

            {/* <!--start Carousal--> */}
            <section style={{ marginTop: "100px" }}>
                <Carousel
                    autoPlay={false}
                    autoPlaySpeed={99999999}
                    containerClass="container"
                    keyBoardControl
                    minimumTouchDrag={80}
                    renderButtonGroupOutside={false}
                    slidesToSlide={1}
                    partialVisible
                    customLeftArrow={<CustomLeftArrow />}
                    customRightArrow={<CustomRightArrow />}
                    responsive={responsive}
                >
                    {
                        brands.map((brand, index) => {
                            return (
                                <div key={index} className="services-two__single wow animated fadeInUp ms-4" data-wow-delay="0.1s">
                                    <div className="services-two__single-img">
                                        <a href={brand.Link} target="_blank">
                                            <img src={variables.PHOTO_URL + brand.Logo} alt="" />
                                        </a>
                                    </div>

                                    <div className="services-two__single-content text-center">
                                        <a href={brand.Link} target="_blank">
                                            <h2>{brand.BrandName}</h2>
                                        </a>
                                    </div>
                                </div>
                            );
                        })
                    }
                </Carousel>
            </section>

            {/* <!--End Carousel --> */}
            {/* <!--Start About One--> */}
            <section className="about-one about-one--two">
                <div className="container">
                    <div className="row">
                        {/* <!--Start About One Img Box--> */}
                        <div className="col-xl-6">
                            <div className="about-one__img">
                                <div className="shape1 zoom-fade"><img src="/assets/images/shapes/about-v1-shape1.png" alt="" />
                                </div>
                                <div className="about-one__img1">
                                    {
                                        about && about.BackImageUrl != "" && about.BackImageUrl != null && (

                                            <img src={variables.PHOTO_URL + about.BackImageUrl} alt="" style={{ width: "525px", height: "517px", objectFit: "cover", }} />
                                        )
                                    }
                                </div>

                                <div className="about-one__img2">
                                    {
                                        about && about.FrontImageUrl != "" && about.FrontImageUrl != null && (

                                            <img src={variables.PHOTO_URL + about.FrontImageUrl} alt="" style={{ width: "380px", height: "560px", objectFit: "cover" }} />
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                        {/* <!--End About One Img Box--> */}

                        {/* <!--Start About One Content--> */}
                        <div className="col-xl-6">
                            <div className="about-one__content">
                                <div className="sec-title">
                                    <span className="sec-title__tagline sec-title__title">{about && about.Title}</span>
                                    {/* <h2 className="sec-title__title">We are a modern <br />Flooring agency...</h2> */}
                                </div>
                                { aboutText && aboutText.map((item, index) => (
                                        <div key={index} className={`about-two__content-text-child ${index === 0 ? 'first-child' : 'other-children'}`}>
                                            <p>
                                                {item}
                                            </p>
                                    </div>
                                    ) ) 
                                }
                            </div>
                        </div>
                        {/* <!--End About One Content--> */}
                    </div>
                </div>
            </section>
            {/* <!--End About One--> */}

            {/* <!--Start Product One--> */}
            <section className="product-one">
                <div className="container">
                    <div className="sec-title text-center">
                        {/* <span className=" sec-title__tagline">Shop Our Product</span> */}
                        <h2 className="sec-title__title">Our Products</h2>
                    </div>
                    <div className="row">
                        {/* <!--Start Single Product One--> */}
                        {
                            shuffledContent.map((shufct, index) => {
                                return (
                                    <div key={index} className="col-xl-4 col-lg-4 col-md-6 wow fadeInLeft" data-wow-delay="0ms"
                                        data-wow-duration="1500ms">
                                        <div className="product-one__single">
                                            <div className="product-one__single-img">
                                                {/* "/assets/images/resources/product-v1-img1.jpg" */}
                                                <a href={"/" + shufct.Url}>
                                                    <img src={variables.PHOTO_URL + shufct.ImageUrl} alt="" />
                                                </a>
                                            </div>

                                            <div className="product-one__single-content text-center">
                                                <h2><a href="#">{shufct.ContentTitle}</a></h2>
                                                {/* <p><span><del>$55.00</del></span> $45.00</p> */}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </section>

            {/* <!--Start Contact One--> */}
            <section className="contact-one contact-one--two">
                <div className="shape1"><img src="/assets/images/shapes/contact-v1-shape1.png" alt="" /></div>
                <div className="contact-one__img" style={{ backgroundImage: `url(${contact && contact.ImageUrl != "" && contact.ImageUrl != null && variables.PHOTO_URL + contact.ImageUrl})` }}>
                    {/* <div className="overlay-content text-center">
                        <h2>{contact && contact.Number}</h2>
                        <h3>Years of <br />Expeirence</h3>
                    </div> */}
                </div>
                <div className="container">
                    <div className="row">
                        {/* <!--Start Contact One Img--> */}
                        <div className="col-xl-6 col-lg-0">

                        </div>
                        {/* <!--End Contact One Img--> */}

                        {/* <!--Start Contact One Content--> */}
                        <div className="col-xl-6 col-lg-12">
                            <div className="contact-one__content">
                                <div className="sec-title">
                                    {/* <span className="sec-title__tagline">Contact us</span> */}
                                    <h2 className="sec-title__title">Get in touch</h2>
                                </div>

                                <div className="contact-one__content-comment-form">
                                    {/* action="/assets/inc/sendemail.php" className="comment-one__form contact-form-validated"
                                        noValidate="novalidate" */}
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-xl-6 col-lg-6 col-md-6">
                                                <div className="comment-form__input-box">
                                                    <input type="text" placeholder="Full Name" name="name" value={name} onChange={(e) => setName(e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="col-xl-6 col-lg-6 col-md-6">
                                                <div className="comment-form__input-box">
                                                    <input type="email" placeholder="Email Addresss" name="email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                                </div>
                                            </div>
                                        </div>


                                        <div className="row">
                                            <div className="col-xl-12 col-lg-12">
                                                <div className="comment-form__input-box">
                                                    <textarea name="message" value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Message Details"></textarea>
                                                </div>
                                                <button type="submit" className="thm-btn comment-form__btn">Send</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>

                            </div>
                        </div>
                        {/* <!--End Contact One Content--> */}
                    </div>
                </div>
            </section>
            {/* <!--End Contact One--> */}
        </>
    )
}

export default Home